<template>
    <div>
        <public-menu></public-menu>
        <llwj-search></llwj-search>
        <bottom-nav></bottom-nav>
        <public-footer></public-footer>
    </div>
</template>

<script>
import Public_menu from "@/components/common/public-top"
import Llwj_search from "@/components/lingleiwanju/Index"
import Bottom_nav from "@/components/common/bottom-nav"
import Footer from "../../components/Footer.vue"
export default{
    components:{
        'public-menu': Public_menu,
        'llwj-search':Llwj_search,
        'bottom-nav': Bottom_nav,
        'public-footer': Footer
    }
}
</script>

<style scoped>
@import url('../../assets/css/style.css');
</style>


// WEBPACK FOOTER //
// src/views/lingleiwanju/Index.vue